import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const SocialLink = ({ socialLink }) => {
  const { key, link, text } = socialLink;

  return (
    <a aria-label={text} className="social-link" href={link} rel="noreferrer" target="_blank">
      <Icon alt={text} height={24} name={key} width={24} />
    </a>
  );
};

SocialLink.propTypes = {
  socialLink: PropTypes.shape({
    key: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default SocialLink;
